<template>
  <div class="cgs-app-main">
    <keep-alive>
      <router-view class="cgs-app-main-content" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view class="cgs-app-main-content" v-if="!$route.meta.keepAlive" />
    <van-tabbar v-model="active" :placeholder="true" route>
      <van-tabbar-item v-for="item in tabbarList" :key="item.name" :name="item.name" replace :to="item.to"
        :badge="item.badge === 0 ? '' : item.badge">
        <span>{{ item.label }}</span>
        <template #icon>
          <span class="iconfont" :class="item.icon"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <van-dialog v-model="showDialog" title="发现新版本" :show-confirm-button="false">
      <div style="margin-left: 30px">
        <div>当前版本号：{{ current }}</div>
        <div>新版本号：{{ svn }}</div>
        <div>更新内容：{{ desc }}</div>
      </div>
      <div style="margin: 30px 0px 10px 0px; text-align: center">
        <van-button @click="showDialog = false" style="margin: 0px 10px">忽略此版本</van-button>
        <van-button type="primary" @click="update" style="margin: 0px 10px">立即更新</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, Dialog, Button } from "vant";
import { NumberMessage } from "@/api/message";
import { getCurrentVersion, compareVersion } from "@/util/tool";
import { getVersions } from "@/api/index";

import { get } from '@/axios/http'
import wx from 'weixin-js-sdk'
export default {
  components: {
    vanTabbar: Tabbar,
    vanTabbarItem: TabbarItem,
    [Dialog.Component.name]: Dialog.Component,
    vanButton: Button
  },
  data() {
    return {
      active: "",
      tabbarList: [
        {
          to: "/main/message",
          name: "message",
          label: "消息",
          icon: "cgsIcon-xiaoxi",
          badge: "",
        },
        {
          to: "/main/staging",
          name: "staging",
          label: "工作台",
          icon: "cgsIcon-gongzuotai",
        },
        {
          to: "/main/home",
          name: "home",
          label: "我",
          icon: "cgsIcon-wode-F",
        }
      ],
      count: "",
      showDialog: false,
      svn: "",
      updateURL: "",
      desc: "",
      current: ""
    };
  },
  beforeRouteUpdate(to, from, next) {
    if (this.nameInTabbar(to.name)) {
      this.active === to.name;
    }
    next();
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 `/users/:id`，在 `/users/1` 和 `/users/2` 之间跳转的时候，
    // 由于会渲染同样的 `UserDetails` 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 因为在这种情况发生的时候，组件已经挂载好了，导航守卫可以访问组件实例 `this`
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.active = to.name;
      // console.log(vm.active)
    });
  },
  methods: {
    async examine() {
      // this.showDialog = true
      let code = process.env.VUE_APP_CODE
      let currentVersion = getCurrentVersion();
      this.current = currentVersion
      let result = await getVersions(code);
      this.svn = result.data.version;
      this.desc = result.data.desc;
      let newVersion = result.data.version;
      this.updateURL = result.data.link;
      let info = compareVersion(currentVersion, newVersion);
      if (info == true) {
        this.showDialog = true;
      } else {
        // this.$message({
        //   message: "本版本已经为最新版本",
        //   center: true,
        // });
      }
    },
    async update() {
      if (this.updateURL !== '') {
        // document.addEventListener('plusready', function () {
        this.showDialog = false;
        let downloader = plus.downloader.createDownload(this.updateURL, {}, function (d, status) {
          if (status == 200) {
            let path = d.filename;
            plus.runtime.install(path);
            this.$message({ message: '更新成功', center: true, showClose: true, });
          } else {
            //下载失败
            this.$message({ message: '更新失败', center: true, showClose: true, });
          }
        });
        downloader.start()
        // })
      }
    },
    nameInTabbar(name) {
      let isIn = false;
      for (let i = 0; i < this.tabbarList.length; i++) {
        let item = this.tabbarList[i];
        if (item.name === name) {
          isIn = true;
          break;
        }
      }
      return isIn;
    },
    async Numberage() {
      let nage = await NumberMessage();
      this.tabbarList[0].badge =
        nage.data[0].notice_total +
        nage.data[1].notice_total +
        nage.data[2].notice_total;
      // window.console.log(this.tabbarList[0].badge)
      // window.console.log(nage.data)
    },
  },
  created() {
    let _this = this
    this.Numberage();
    this.$ws.on("send_notice", async (data) => {
      let noticeCount = await NumberMessage();
      // this.noticeCount = noticeCount
      this.tabbarList[0].badge =
        noticeCount.data[0].notice_total +
        noticeCount.data[1].notice_total +
        noticeCount.data[2].notice_total;
    });
    this.$ws.on("clear_notice", async (data) => {
      let noticeCount = await NumberMessage();
      // this.noticeCount = noticeCount
      this.tabbarList[0].badge =
        noticeCount.data[0].notice_total +
        noticeCount.data[1].notice_total +
        noticeCount.data[2].notice_total;
    });
  },
  mounted() {
    this.examine()
  }
};
</script>

<style scoped>
.cgs-app-main {
  /* height: 100%; */
}

.cgs-app-main-content {
  height: calc(100% - 50px);
}
</style>